import script from "./ChangeVideoCaptionStatusModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeVideoCaptionStatusModal.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeVideoCaptionStatusModal.vue?vue&type=style&index=0&id=2a460b0d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a460b0d"]])

export default __exports__